// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AccountRouteImport } from './routes/account'
import { Route as SearchRouteImport } from './routes/search'
import { Route as TaAccountRouteImport } from './routes/ta.account'
import { Route as TaSearchRouteImport } from './routes/ta.search'

const AboutLazyRouteImport = createFileRoute('/about')()
const CollectionsLazyRouteImport = createFileRoute('/collections')()
const ContactLazyRouteImport = createFileRoute('/contact')()
const JourneyLazyRouteImport = createFileRoute('/journey')()
const ProductsLazyRouteImport = createFileRoute('/products')()
const WeddingGiftingLazyRouteImport = createFileRoute('/wedding-gifting')()
const AccountAddressesLazyRouteImport = createFileRoute('/account/addresses')()
const AccountForgotPasswordLazyRouteImport = createFileRoute('/account/forgot-password')()
const AccountInquiriesLazyRouteImport = createFileRoute('/account/inquiries')()
const AccountInvoicesLazyRouteImport = createFileRoute('/account/invoices')()
const AccountOrdersLazyRouteImport = createFileRoute('/account/orders')()
const AccountRegisterLazyRouteImport = createFileRoute('/account/register')()
const AccountSignInLazyRouteImport = createFileRoute('/account/sign-in')()
const AccountWishlistLazyRouteImport = createFileRoute('/account/wishlist')()
const CollectionsSlugLazyRouteImport = createFileRoute('/collections_/$slug')()
const OffersSlugLazyRouteImport = createFileRoute('/offers/$slug')()
const ProductsSlugLazyRouteImport = createFileRoute('/products_/$slug')()
const TaIndexLazyRouteImport = createFileRoute('/ta/')()
const TaAboutLazyRouteImport = createFileRoute('/ta/about')()
const TaCollectionsLazyRouteImport = createFileRoute('/ta/collections')()
const TaContactLazyRouteImport = createFileRoute('/ta/contact')()
const TaJourneyLazyRouteImport = createFileRoute('/ta/journey')()
const TaProductsLazyRouteImport = createFileRoute('/ta/products')()
const TaWeddingGiftingLazyRouteImport = createFileRoute('/ta/wedding-gifting')()
const AccountOrdersOrderIdLazyRouteImport = createFileRoute('/account/orders/$orderId')()
const TaAccountAddressesLazyRouteImport = createFileRoute('/ta/account/addresses')()
const TaAccountForgotPasswordLazyRouteImport = createFileRoute('/ta/account/forgot-password')()
const TaAccountInquiriesLazyRouteImport = createFileRoute('/ta/account/inquiries')()
const TaAccountInvoicesLazyRouteImport = createFileRoute('/ta/account/invoices')()
const TaAccountOrdersLazyRouteImport = createFileRoute('/ta/account/orders')()
const TaAccountRegisterLazyRouteImport = createFileRoute('/ta/account/register')()
const TaAccountSignInLazyRouteImport = createFileRoute('/ta/account/sign-in')()
const TaAccountWishlistLazyRouteImport = createFileRoute('/ta/account/wishlist')()
const TaCollectionsSlugLazyRouteImport = createFileRoute('/ta/collections_/$slug')()
const TaOffersSlugLazyRouteImport = createFileRoute('/ta/offers/$slug')()
const TaProductsSlugLazyRouteImport = createFileRoute('/ta/products_/$slug')()
const TaAccountOrdersOrderIdLazyRouteImport = createFileRoute('/ta/account/orders/$orderId')()

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const AboutLazyRoute = AboutLazyRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/about.lazy').then((d) => d.Route))
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/account.lazy').then((d) => d.Route))
const CollectionsLazyRoute = CollectionsLazyRouteImport.update({
            id: '/collections',path: '/collections',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/collections.lazy').then((d) => d.Route))
const ContactLazyRoute = ContactLazyRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/contact.lazy').then((d) => d.Route))
const JourneyLazyRoute = JourneyLazyRouteImport.update({
            id: '/journey',path: '/journey',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/journey.lazy').then((d) => d.Route))
const ProductsLazyRoute = ProductsLazyRouteImport.update({
            id: '/products',path: '/products',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/products.lazy').then((d) => d.Route))
const SearchRoute = SearchRouteImport.update({
            id: '/search',path: '/search',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/search.lazy').then((d) => d.Route))
const WeddingGiftingLazyRoute = WeddingGiftingLazyRouteImport.update({
            id: '/wedding-gifting',path: '/wedding-gifting',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/wedding-gifting.lazy').then((d) => d.Route))
const AccountAddressesLazyRoute = AccountAddressesLazyRouteImport.update({
            id: '/addresses',path: '/addresses',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account.addresses.lazy').then((d) => d.Route))
const AccountForgotPasswordLazyRoute = AccountForgotPasswordLazyRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account.forgot-password.lazy').then((d) => d.Route))
const AccountInquiriesLazyRoute = AccountInquiriesLazyRouteImport.update({
            id: '/inquiries',path: '/inquiries',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account.inquiries.lazy').then((d) => d.Route))
const AccountInvoicesLazyRoute = AccountInvoicesLazyRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account.invoices.lazy').then((d) => d.Route))
const AccountOrdersLazyRoute = AccountOrdersLazyRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account.orders.lazy').then((d) => d.Route))
const AccountRegisterLazyRoute = AccountRegisterLazyRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account.register.lazy').then((d) => d.Route))
const AccountSignInLazyRoute = AccountSignInLazyRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account.sign-in.lazy').then((d) => d.Route))
const AccountWishlistLazyRoute = AccountWishlistLazyRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => AccountRoute
          }).lazy(() => import('./routes/account.wishlist.lazy').then((d) => d.Route))
const CollectionsSlugLazyRoute = CollectionsSlugLazyRouteImport.update({
            id: '/collections_/$slug',path: '/collections/$slug',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/collections_.$slug.lazy').then((d) => d.Route))
const OffersSlugLazyRoute = OffersSlugLazyRouteImport.update({
            id: '/offers/$slug',path: '/offers/$slug',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/offers.$slug.lazy').then((d) => d.Route))
const ProductsSlugLazyRoute = ProductsSlugLazyRouteImport.update({
            id: '/products_/$slug',path: '/products/$slug',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/products_.$slug.lazy').then((d) => d.Route))
const TaIndexLazyRoute = TaIndexLazyRouteImport.update({
            id: '/ta/',path: '/ta/',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.index.lazy').then((d) => d.Route))
const TaAboutLazyRoute = TaAboutLazyRouteImport.update({
            id: '/ta/about',path: '/ta/about',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.about.lazy').then((d) => d.Route))
const TaAccountRoute = TaAccountRouteImport.update({
            id: '/ta/account',path: '/ta/account',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.account.lazy').then((d) => d.Route))
const TaCollectionsLazyRoute = TaCollectionsLazyRouteImport.update({
            id: '/ta/collections',path: '/ta/collections',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.collections.lazy').then((d) => d.Route))
const TaContactLazyRoute = TaContactLazyRouteImport.update({
            id: '/ta/contact',path: '/ta/contact',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.contact.lazy').then((d) => d.Route))
const TaJourneyLazyRoute = TaJourneyLazyRouteImport.update({
            id: '/ta/journey',path: '/ta/journey',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.journey.lazy').then((d) => d.Route))
const TaProductsLazyRoute = TaProductsLazyRouteImport.update({
            id: '/ta/products',path: '/ta/products',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.products.lazy').then((d) => d.Route))
const TaSearchRoute = TaSearchRouteImport.update({
            id: '/ta/search',path: '/ta/search',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.search.lazy').then((d) => d.Route))
const TaWeddingGiftingLazyRoute = TaWeddingGiftingLazyRouteImport.update({
            id: '/ta/wedding-gifting',path: '/ta/wedding-gifting',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.wedding-gifting.lazy').then((d) => d.Route))
const AccountOrdersOrderIdLazyRoute = AccountOrdersOrderIdLazyRouteImport.update({
            id: '/$orderId',path: '/$orderId',getParentRoute: () => AccountOrdersLazyRoute
          }).lazy(() => import('./routes/account.orders.$orderId.lazy').then((d) => d.Route))
const TaAccountAddressesLazyRoute = TaAccountAddressesLazyRouteImport.update({
            id: '/addresses',path: '/addresses',getParentRoute: () => TaAccountRoute
          }).lazy(() => import('./routes/ta.account.addresses.lazy').then((d) => d.Route))
const TaAccountForgotPasswordLazyRoute = TaAccountForgotPasswordLazyRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => TaAccountRoute
          }).lazy(() => import('./routes/ta.account.forgot-password.lazy').then((d) => d.Route))
const TaAccountInquiriesLazyRoute = TaAccountInquiriesLazyRouteImport.update({
            id: '/inquiries',path: '/inquiries',getParentRoute: () => TaAccountRoute
          }).lazy(() => import('./routes/ta.account.inquiries.lazy').then((d) => d.Route))
const TaAccountInvoicesLazyRoute = TaAccountInvoicesLazyRouteImport.update({
            id: '/invoices',path: '/invoices',getParentRoute: () => TaAccountRoute
          }).lazy(() => import('./routes/ta.account.invoices.lazy').then((d) => d.Route))
const TaAccountOrdersLazyRoute = TaAccountOrdersLazyRouteImport.update({
            id: '/orders',path: '/orders',getParentRoute: () => TaAccountRoute
          }).lazy(() => import('./routes/ta.account.orders.lazy').then((d) => d.Route))
const TaAccountRegisterLazyRoute = TaAccountRegisterLazyRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => TaAccountRoute
          }).lazy(() => import('./routes/ta.account.register.lazy').then((d) => d.Route))
const TaAccountSignInLazyRoute = TaAccountSignInLazyRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => TaAccountRoute
          }).lazy(() => import('./routes/ta.account.sign-in.lazy').then((d) => d.Route))
const TaAccountWishlistLazyRoute = TaAccountWishlistLazyRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => TaAccountRoute
          }).lazy(() => import('./routes/ta.account.wishlist.lazy').then((d) => d.Route))
const TaCollectionsSlugLazyRoute = TaCollectionsSlugLazyRouteImport.update({
            id: '/ta/collections_/$slug',path: '/ta/collections/$slug',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.collections_.$slug.lazy').then((d) => d.Route))
const TaOffersSlugLazyRoute = TaOffersSlugLazyRouteImport.update({
            id: '/ta/offers/$slug',path: '/ta/offers/$slug',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.offers.$slug.lazy').then((d) => d.Route))
const TaProductsSlugLazyRoute = TaProductsSlugLazyRouteImport.update({
            id: '/ta/products_/$slug',path: '/ta/products/$slug',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/ta.products_.$slug.lazy').then((d) => d.Route))
const TaAccountOrdersOrderIdLazyRoute = TaAccountOrdersOrderIdLazyRouteImport.update({
            id: '/$orderId',path: '/$orderId',getParentRoute: () => TaAccountOrdersLazyRoute
          }).lazy(() => import('./routes/ta.account.orders.$orderId.lazy').then((d) => d.Route))





const AccountOrdersLazyRouteChildren = {
  AccountOrdersOrderIdLazyRoute: AccountOrdersOrderIdLazyRoute
}

const AccountOrdersLazyRouteWithChildren = AccountOrdersLazyRoute._addFileChildren(AccountOrdersLazyRouteChildren)



const AccountRouteChildren = {
  AccountAddressesLazyRoute: AccountAddressesLazyRoute,AccountForgotPasswordLazyRoute: AccountForgotPasswordLazyRoute,AccountInquiriesLazyRoute: AccountInquiriesLazyRoute,AccountInvoicesLazyRoute: AccountInvoicesLazyRoute,AccountOrdersLazyRoute: AccountOrdersLazyRouteWithChildren,AccountRegisterLazyRoute: AccountRegisterLazyRoute,AccountSignInLazyRoute: AccountSignInLazyRoute,AccountWishlistLazyRoute: AccountWishlistLazyRoute
}

const AccountRouteWithChildren = AccountRoute._addFileChildren(AccountRouteChildren)




const TaAccountOrdersLazyRouteChildren = {
  TaAccountOrdersOrderIdLazyRoute: TaAccountOrdersOrderIdLazyRoute
}

const TaAccountOrdersLazyRouteWithChildren = TaAccountOrdersLazyRoute._addFileChildren(TaAccountOrdersLazyRouteChildren)



const TaAccountRouteChildren = {
  TaAccountAddressesLazyRoute: TaAccountAddressesLazyRoute,TaAccountForgotPasswordLazyRoute: TaAccountForgotPasswordLazyRoute,TaAccountInquiriesLazyRoute: TaAccountInquiriesLazyRoute,TaAccountInvoicesLazyRoute: TaAccountInvoicesLazyRoute,TaAccountOrdersLazyRoute: TaAccountOrdersLazyRouteWithChildren,TaAccountRegisterLazyRoute: TaAccountRegisterLazyRoute,TaAccountSignInLazyRoute: TaAccountSignInLazyRoute,TaAccountWishlistLazyRoute: TaAccountWishlistLazyRoute
}

const TaAccountRouteWithChildren = TaAccountRoute._addFileChildren(TaAccountRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRoute: AccountRouteWithChildren,SearchRoute: SearchRoute,AboutLazyRoute: AboutLazyRoute,CollectionsLazyRoute: CollectionsLazyRoute,ContactLazyRoute: ContactLazyRoute,JourneyLazyRoute: JourneyLazyRoute,ProductsLazyRoute: ProductsLazyRoute,WeddingGiftingLazyRoute: WeddingGiftingLazyRoute,TaAccountRoute: TaAccountRouteWithChildren,TaSearchRoute: TaSearchRoute,CollectionsSlugLazyRoute: CollectionsSlugLazyRoute,OffersSlugLazyRoute: OffersSlugLazyRoute,ProductsSlugLazyRoute: ProductsSlugLazyRoute,TaAboutLazyRoute: TaAboutLazyRoute,TaCollectionsLazyRoute: TaCollectionsLazyRoute,TaContactLazyRoute: TaContactLazyRoute,TaJourneyLazyRoute: TaJourneyLazyRoute,TaProductsLazyRoute: TaProductsLazyRoute,TaWeddingGiftingLazyRoute: TaWeddingGiftingLazyRoute,TaIndexLazyRoute: TaIndexLazyRoute,TaCollectionsSlugLazyRoute: TaCollectionsSlugLazyRoute,TaOffersSlugLazyRoute: TaOffersSlugLazyRoute,TaProductsSlugLazyRoute: TaProductsSlugLazyRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)